import styled from 'styled-components';
import { colors } from '@config/colors';

/*
 * A demo phone whose foot fades away (June, 2026-09-23: "just a fade to
 * white … to prevent unnecessary visual clutter of the bottom of the
 * app"). The phone — screen, bezel and all — fades out through its lower
 * quarter, gone before the app's tab bar begins, into what lies beneath:
 * the white card on the homepage, the pale page on a product's page. Its
 * shadow is cast from what the fade leaves, so it fades with it.
 *
 * Wrap the phone in it, at the phone's own size; style it as the phone's
 * spot (grid area, centring).
 */
export const FadingPhone = styled.div`
  filter: drop-shadow(0 18px 26px ${colors.shadowHard});

  > * {
    -webkit-mask-image: linear-gradient(to bottom, ${colors.white} 58%, transparent 84%);
    mask-image: linear-gradient(to bottom, ${colors.white} 58%, transparent 84%);
  }
`;
